import Axios from 'axios';
import { baseApiRoute } from './../../../../assets/const';

const headers = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*'
};

let config = {
  baseURL: baseApiRoute,
  headers: headers
};

const HttpClient = Axios.create(config);

export default HttpClient;



// WEBPACK FOOTER //
// ./src/services/api-client/resource/base/HttpClient.jsx